import React from 'react';
import { Link } from "react-router-dom";
import { Label } from '../../atoms/RTCC/label';

export const BreadCrumb = (props) => {
    const { breadCrumbStyle, linkStyle, linkList, lastLabel, lastLabelClassName } = props;
    return (
        <div style={breadCrumbStyle}>
            {linkList.map((value, index) => (
                <div key={"link" + index} style={{ display: "flex" }}>
                    <Link to={value.path} style={linkStyle}>{value.label}</Link>
                    <Label label=">" className={lastLabelClassName} />
                </div>
            ))}
            <Label label={lastLabel} className={lastLabelClassName} />
        </div>
    );
}
